/**
 * 企業ページ配下 (/company/ 以下) の CTA から plan-request へ遷移するときの query string (先頭の ? なし) を作る。
 * speee/dx-totty#3310
 *
 * - 今いるページの URL に utm_source / ieul_source がある (広告などから直接来た) 場合は、元のパラメータだけを引き継ぐ。
 *   ieul_* は plan-request 側で utm_* を上書きするため、付けると広告の流入元が消えてしまう。
 * - 無い場合は、元のパラメータ (gclid など) に続けて、このページと置き場所を表す ieul_* を付ける。
 *   ieul_content には今いるページの URL を入れる。utm_content 内の ?utm_source=… を流入元として拾う処理が
 *   plan-request 側にあるため、パラメータ (?) とハッシュ (#) は含めない。
 *
 * @param medium ページの種類 (例: company_detail)
 * @param term   ページ内の置き場所 (例: bottom_compare)
 */
export function buildCompanyPlanRequestQuery(medium: string, term: string): string {
  const inbound = location.search.replace(/^\?/, "");
  const inboundParams = new URLSearchParams(inbound);
  if (inboundParams.has("utm_source") || inboundParams.has("ieul_source")) return inbound;

  // URLSearchParams#toString で ieul_content の URL はエンコードされる
  const own = new URLSearchParams({
    ieul_source: "organic",
    ieul_medium: medium,
    ieul_campaign: "land_company",
    ieul_term: term,
    ieul_content: location.origin + location.pathname,
  }).toString();

  return [inbound, own].filter(Boolean).join("&");
}
